// Topbar icons
import top_1 from "../assets/icons/top-1.png";
import top_2 from "../assets/icons/top-2.png";
import top_3 from "../assets/icons/top-3.png";
import top_4 from "../assets/icons/top-4.png";
// Category icons
import cate_1 from "../assets/icons/cate-1.png";
import cate_2 from "../assets/icons/cate-2.png";
import cate_3 from "../assets/icons/cate-3.png";

export const text =
  "Giftofgodfragrances.com is a New Jersey-based online brand name fragrance retailer which was founded in 2016. Since then Giftofgodfragrances.com has delivered quality products, at competitive prices with outstanding customer service. Giftofgodfragrances.com is a New Jersey-based online brand name fragrance retailer which was founded in 2016. Since then Giftofgodfragrances.com has delivered quality products, at competitive prices with outstanding customer service. Giftofgodfragrances.com is a New Jersey-based online brand name fragrance retailer which was founded in 2016. Since then Giftofgodfragrances.com has delivered quality products, at competitive prices with outstanding customer service.";

export const top = [
  {
    id: 1,
    title: "+1 123 456 7890",
    image: top_1,
  },
  {
    id: 2,
    title: "Track Your Order",
    image: top_2,
  },
  {
    id: 3,
    title: "Join Our Newsletter",
    image: top_3,
  },
  {
    id: 4,
    title: "Free (U.S) Shipping (Over $59.95)",
    image: top_4,
  },
];

export const categories = [
  {
    id: 1,
    title: "Free U.S. Shipping",
    // price: "$59.95",
    detail: "On orders over $100.",
    icon: cate_1,
  },
  {
    id: 2,
    title: "Secure Payment",
    // secure: "100%",
    detail: "100% safe and protected via PEV",
    icon: cate_2,
  },
  {
    id: 3,
    title: "30-Day Returns",

    detail: "Easy returns within 30 days.",
    icon: cate_3,
  },
];

export const faqs = [
  {
    id: 1,
    question: "Overview",
    answer:
      "Aruhi Fragrances offers premium, long-lasting perfumes designed to create a signature scent for every individual. Our collections combine exquisite ingredients with expert craftsmanship, ensuring a luxurious and unforgettable fragrance experience for every customer.",
  },
  {
    id: 2,
    question: "Benefits of Buying Perfumes Online from Aruhi Fragrances",
    answer:
      "Shopping online at Aruhi Fragrances is convenient, safe, and fast. You get access to exclusive collections, authentic products, secure payment options, and doorstep delivery. Our detailed descriptions and customer reviews help you make confident choices effortlessly.",
  },
  {
    id: 3,
    question: "Enjoy Special Offers & Discount At Aruhi Fragrances",
    answer:
      "We regularly offer special promotions, seasonal discounts, and loyalty rewards to give our customers extra value. By subscribing to our newsletter or following us on social media, you can stay updated on exclusive deals and limited-time offers.",
  },
  {
    id: 4,
    question: "FAQ",
    answer:
      "Our FAQ section provides answers to common questions regarding products, shipping, returns, and online purchases. It helps customers understand our policies, services, and offers, making their shopping experience smooth, informed, and enjoyable.",
  },
];

export const tabs = [
  {
    id: 1,
    title: "Trending",
    tag: "Trending",
  },
  {
    id: 2,
    title: "Staff Picks",
    tag: "Staff Picks",
  },
  {
    id: 3,
    title: "Just In",
    tag: "Just In",
  },
];
